import { c as _c } from "react/compiler-runtime";
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { ChecklistItemRow } from './checklist-item-row';
import type { ChecklistItem } from './checklist-utils';
interface ChecklistItemsProps {
  groupedItems: Record<string, ChecklistItem[]>;
  checkedItems: Set<string>;
  onToggleItem: (itemId: string) => void;
  onShowOnMap: (itemId: string) => void;
  totalItems: number;
  selectedItemId?: string | null;
}
export const ChecklistItems = t0 => {
  const $ = _c(37);
  const {
    groupedItems,
    checkedItems,
    onToggleItem,
    onShowOnMap,
    totalItems,
    selectedItemId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  if (totalItems === 0) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = css.raw({
        paddingTop: "12"
      });
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t) {
      t3 = t(_temp);
      $[2] = t;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t3) {
      t4 = <Type variant="header-s" color="text.secondary">{t3}</Type>;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = css({
        textAlign: "center"
      });
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] !== t) {
      t6 = t(_temp2);
      $[7] = t;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] !== t5 || $[10] !== t6) {
      t7 = <Type variant="body-xs" color="text.secondary" className={t5}>{t6}</Type>;
      $[9] = t5;
      $[10] = t6;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    let t8;
    if ($[12] !== t2 || $[13] !== t4 || $[14] !== t7) {
      t8 = <FlexColumn width="full" gap="6" align="center" className={t2}>{t4}{t7}</FlexColumn>;
      $[12] = t2;
      $[13] = t4;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    return t8;
  }
  if (Object.keys(groupedItems).length === 0) {
    let t2;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = css.raw({
        paddingTop: "12"
      });
      $[16] = t2;
    } else {
      t2 = $[16];
    }
    let t3;
    if ($[17] !== t) {
      t3 = t(_temp3);
      $[17] = t;
      $[18] = t3;
    } else {
      t3 = $[18];
    }
    let t4;
    if ($[19] !== t3) {
      t4 = <Type variant="header-s" color="text.secondary">{t3}</Type>;
      $[19] = t3;
      $[20] = t4;
    } else {
      t4 = $[20];
    }
    let t5;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = css({
        textAlign: "center"
      });
      $[21] = t5;
    } else {
      t5 = $[21];
    }
    let t6;
    if ($[22] !== t) {
      t6 = t(_temp4);
      $[22] = t;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    let t7;
    if ($[24] !== t5 || $[25] !== t6) {
      t7 = <Type variant="body-xs" color="text.secondary" className={t5}>{t6}</Type>;
      $[24] = t5;
      $[25] = t6;
      $[26] = t7;
    } else {
      t7 = $[26];
    }
    let t8;
    if ($[27] !== t2 || $[28] !== t4 || $[29] !== t7) {
      t8 = <FlexColumn width="full" gap="6" align="center" className={t2}>{t4}{t7}</FlexColumn>;
      $[27] = t2;
      $[28] = t4;
      $[29] = t7;
      $[30] = t8;
    } else {
      t8 = $[30];
    }
    return t8;
  }
  let t2;
  if ($[31] !== checkedItems || $[32] !== groupedItems || $[33] !== onShowOnMap || $[34] !== onToggleItem || $[35] !== selectedItemId) {
    t2 = <FlexColumn gap="12" width="full">{Object.entries(groupedItems).map(t3 => {
        const [categoryTitle, items] = t3;
        return <FlexColumn key={categoryTitle} gap="8" width="full">{items.map(item => <ChecklistItemRow key={item.id} item={item} isChecked={checkedItems.has(item.id)} isSelected={selectedItemId === item.id} onToggle={onToggleItem} onShowOnMap={onShowOnMap} />)}</FlexColumn>;
      })}</FlexColumn>;
    $[31] = checkedItems;
    $[32] = groupedItems;
    $[33] = onShowOnMap;
    $[34] = onToggleItem;
    $[35] = selectedItemId;
    $[36] = t2;
  } else {
    t2 = $[36];
  }
  return t2;
};
function _temp($) {
  return $.checklist_pages.no_checklist_items_available;
}
function _temp2($_0) {
  return $_0.checklist_pages.no_items_display_message;
}
function _temp3($_1) {
  return $_1.no_results_found;
}
function _temp4($_2) {
  return $_2.no_results_message;
}